<template>
  <b-container fluid class="p-0" :style="{ height: 'calc(100% - ' + headerHeight + ')' }">
    <b-row v-if="isMobile" no-gutters class="h-100" style="background-color: #ff0000;">
      <b-col>
        <b-card no-body class="border-0 h-100 rounded-0">
          <b-tabs card pills justified nav-wrapper-class="sticky-top bg-white" style="height: calc(100% - 65px);">
            <b-tab title="Platforms" class="p-0">
              <platforms-open-widget></platforms-open-widget>
            </b-tab>
            <b-tab title="Map" class="p-0 h-100" active @click="refreshViewport()">
              <navigator-widget ref="navigator"></navigator-widget>
            </b-tab>
            <b-tab title="Feed" class="p-0" v-if="!('embed' in this.$route.query)">
              <media-feed-widget v-if="hasMediaFeed"></media-feed-widget>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="!isMobile" no-gutters class="h-100">
      <b-col class="sidebar-platforms" ref="sidebarPlatforms" :class="sidebarPlatformsClass()">
        <platforms-open-widget v-if="sidebarCollapseState('sidebar-platforms')"></platforms-open-widget>
        <platforms-minimized-widget v-else></platforms-minimized-widget>
      </b-col>
      <b-col>
        <vue-split style="height: calc(100% - 3px);" ref="splitpanes"
                   :elements="['#slotNavigator', '#slotCharts']"
                   direction="vertical"
                   :sizes="[100, 0]"
                   :min-size="[300, 0]"
                   :gutter-size="5"
                   :snap-offset="20" @onDragEnd="handleSplitpanesResize">
          <div id="slotNavigator">
            <navigator-widget ref="navigator"></navigator-widget>
          </div>
          <div id="slotCharts" ref="slotCharts">
            <chart-widget ref="chart"></chart-widget>
          </div>
        </vue-split>
      </b-col>
      <b-col class="sidebar-feed collapse h-100" :class="sidebarFeedClass()">
        <media-feed-widget v-if="hasMediaFeed"></media-feed-widget>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <cookie-law theme="blood-orange" buttonText="I understand">
          <div slot="message">
            We use cookies to provide and improve our service. We do not leak or sell the collected data to third parties. By continuing, you consent to our <a href="https://www.geomar.de/en/datenschutz" target="_blank">Privacy Policy</a>.
          </div>
        </cookie-law>
      </b-col>
    </b-row>
    <data-popup-modal></data-popup-modal>
  </b-container>
</template>

<script>

import { mapGetters, mapMutations, mapState } from 'vuex'

import Helpers from '@/mixins/helpers'
import VueSplit from '@/../node_modules_adapted/vue-splitjs/vue-splitjs.min'
import PlatformsOpenWidget from '@/components/widgets/PlatformsOpenWidget'
import PlatformsMinimizedWidget from '@/components/widgets/PlatformsMinimizedWidget'
import NavigatorWidget from '@/components/widgets/NavigatorWidget'
import MediaFeedWidget from '@/components/widgets/MediaFeedWidget'
import ChartWidget from '@/components/widgets/ChartWidget'
import CookieLaw from 'vue-cookie-law'
import DataPopupModal from '@/components/modals/DataPopupModal.vue'

const CHARTPANE_INITIAL_PERCENTAGE = 30
const COLLAPSE_TOGGLE_DURATION = 400
const MEDIUM_BREAKPOINT = 1024

export default {
  name: 'MainWindow',
  data: function () {
    return {
      tracking_consent: true
    }
  },
  mixins: [
    Helpers
  ],
  components: {
    DataPopupModal,
    MediaFeedWidget,
    NavigatorWidget,
    ChartWidget,
    PlatformsOpenWidget,
    PlatformsMinimizedWidget,
    VueSplit,
    CookieLaw
  },
  beforeDestroy: function () {
    // Unsubscribe from mutations
    this.unsubscribe()
  },
  mounted: function () {
    // const component = this
    // Subscribe to store mutations
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'toggle_collapse') {
        this.$refs.chart.beforeRefresh()
        this.refreshViewport(COLLAPSE_TOGGLE_DURATION)
      } else if (mutation.type === 'select_parameter') {
        if (typeof this.$refs.splitpanes !== 'undefined') {
          const split = this.$refs.splitpanes.instance
          if (this.selectedParameter !== null) {
            if (split.getSizes()[1] < CHARTPANE_INITIAL_PERCENTAGE) {
              // FIXME: Workaround because vue-splitjs ist not responsive
              split.setSizes([100 - CHARTPANE_INITIAL_PERCENTAGE, CHARTPANE_INITIAL_PERCENTAGE])
              this.refreshViewport() // TODO: Necessary?
            }
          } else {
            // FIXME: Workaround because vue-splitjs ist not responsive
            split.setSizes([100, 0])
            this.refreshViewport() // TODO: Necessary?
          }
        }
      }
    })
    // Listen to window resize events
    this.$root.$on('windowResize', (dimensions) => {
      // Always deselect parameter first to close chart etc
      this.select_parameter(null)
      this.refreshViewport()
    })
    // Initialize collapsable components
    this.set_collapse({ component: 'sidebar-platforms', value: true })
  },
  methods: {
    ...mapMutations(['set_collapse', 'select_parameter']),
    // handleTrackingConsent: function (consent) {
    //   this.$matomo.setConsentGiven(consent)
    // },
    handleSplitpanesResize: function (size) {
      this.refreshViewport()
    },
    refreshViewport: function (timeout = 0) {
      const component = this
      setTimeout(function () {
        if ('navigator' in component.$refs) {
          component.$refs.navigator.refreshViewport()
        }
        if ('chart' in component.$refs) {
          component.$refs.chart.refreshViewport(component.$refs.slotCharts.clientHeight)
        }
      }, timeout)
    },
    sidebarCollapseState: function (componentId) {
      return this.collapseStates[componentId]
    },
    sidebarFeedClass: function () {
      if (this.collapseStates['sidebar-feed']) {
        return 'show'
      }
      return 'hide'
    },
    sidebarPlatformsClass: function () {
      if (this.collapseStates['sidebar-platforms']) {
        return 'sidebar-platforms-open'
      }
      return 'sidebar-platforms-minimized'
    }
  },
  computed: {
    ...mapState(['collapseStates', 'selectedParameter', 'selectedCampaign']),
    ...mapGetters(['campaignSelected']),
    headerHeight: function () {
      if ('embed' in this.$route.query) {
        return '0px'
      } else if (this.selectedCampaign !== 0 && this.campaignSelected.message !== '') {
        return '156px'
      }
      return '114px'
    },
    isMobile: function () {
      return this.$root.window.width <= MEDIUM_BREAKPOINT
    },
    hasMediaFeed: function () {
      return (this.selectedCampaign !== 0 && this.campaignSelected.project_feed !== '' &&
        'project_feed_data' in this.campaignSelected)
    }
  }
}
</script>

<style>

.split {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.gutter {
  background-color: rgba(0, 0, 0, 0.125) !important;
  background-repeat: no-repeat;
  background-position: 50%;
}

.gutter.gutter-vertical {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=') !important;
}

.tab-content {
  height: 100%;
  overflow-y: hidden;
}

</style>

<style scoped>

.bg-white {
  background-color: #ffffff;
}

.sidebar-platforms {
  height: 100%;
  border-right: 1px solid rgba(0, 0, 0, 0.125);
}

.sidebar-platforms-open {
  -ms-flex: 0 0 600px;
  flex: 0 0 600px;
}

.sidebar-platforms-minimized {
  -ms-flex: 0 0 350px;
  flex: 0 0 350px;
}

.sidebar-feed {
  -ms-flex: 0 350px;
  flex: 0 0 350px;
  border-left: 1px solid rgba(0, 0, 0, 0.125);
}

</style>
